// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zL7if{margin:10px 0 30px;position:relative;text-align:center}.G5YQb{color:#4a4a4a;font-size:14px;font-weight:600;margin:0}.KouS8{color:#a3aeb2;font-size:12px;line-height:1.83;margin:0 0 13px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `zL7if`,
	"title": `G5YQb`,
	"text": `KouS8`
};
module.exports = ___CSS_LOADER_EXPORT___;
